import React, { useState } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';

import './AppointmentDialog.scss';

export default function AppointmentDialog(props) {

  const [postingApp, setPosting] = useState(false)
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  const postApp = () => {
    setPosting(true);

    var body = {
      'firstname': props.formState.firstName,
      'lastname': props.formState.lastName,
      'state': props.formState.state,
      'phone': props.formState.phone.replace(/\D/g, ''),
      'email': props.formState.email,
    }

    fetch(`${covrServicesUrl}/api/SeniorMarketSales/Submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(body),
    })
      .then(response => response.json())
      .then((data) => {
        if (data.success) {
          props.onNext();
        }
        else {
          setPosting(false);
        }
      }).catch((error) => {
        setPosting(false);
      })
  }
  return (
    <Dialog maxWidth="sm" className="appointment-dialog" open={props.open} onClose={props.onDialogClosed} scroll="body">
      <DialogTitle className='px-4'>Starting Application</DialogTitle>
      <IconButton
        className="product-info-close-button"
        aria-label="close"
        onClick={props.onDialogClosed}
        size="large">
        <CloseIcon />
      </IconButton>
      <DialogContent className="product-info-dialog-content">
        <p>
          By providing your name and contact information you are consenting to receive calls, text messages and/or emails from a licensed insurance agent about Medicare Plans at the number provided, and you agree such calls and/or text messages may use an auto-dialer or robocall, even if you are on a government do-not-call registry. This agreement is not a condition of enrollment.
        </p>
        <Row className="justify-content-center">
          <div className='mb-3'>
            {postingApp ?
              <div className="submit-loading-container"><CircularProgress /></div> :
              <Button variant="contained" color="primary" onClick={postApp} fullWidth>REQUEST MY APPOINTMENT</Button>
            }
          </div>
        </Row>
      </DialogContent>
    </Dialog>
  );
}

AppointmentDialog.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onDialogClosed: PropTypes.func.isRequired,
};
